

import { TypedUseSelectorHook, useSelector } from 'react-redux';
import type { RootState } from '../redux/store';

// Typed useSelector
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
